// KerjaBareng wordmark ("kerja·bareng"). `layout/wordmark.tsx` still renders Bystep's by·step, so the
// shell uses this one; same `.wordmark` styling so both products look like siblings.
import { Link } from '@tanstack/react-router'
import { cn } from '#/lib/utils'
import { m } from '#/paraglide/messages'
import { Mascot } from '#/components/brand/mascot'

export function KbWordmark({ className, size = 'md', to = '/home', asSpan = false }: { className?: string; size?: 'sm' | 'md' | 'lg'; to?: '/' | '/home'; asSpan?: boolean }) {
  const sz = size === 'lg' ? 'text-3xl' : size === 'sm' ? 'text-base' : 'text-xl'
  const inner = (
    <>
      <Mascot className={size === 'lg' ? 'size-11' : size === 'sm' ? 'size-6' : 'size-8'} priority />
      <span>kerja<span className="dot">·</span>bareng</span>
    </>
  )
  if (asSpan) return <span className={cn('wordmark inline-flex items-center gap-2 whitespace-nowrap select-none', sz, className)}>{inner}</span>
  return (
    <Link to={to} className={cn('wordmark inline-flex items-center gap-2 whitespace-nowrap select-none', sz, className)} aria-label={m.app_name()}>
      {inner}
    </Link>
  )
}

/** Mascot mark for compact navigation. */
export function KbMark({ className }: { className?: string }) {
  return (
    <Mascot className={cn('size-7', className)} priority />
  )
}
